import React, { Component } from "react";
import Head from "next/head";
import { connect } from "react-redux";
import withRouterPageLayout from "@components/withRouterPageLayout.js";
import getConfig from "next/config";

import { getRegionsWithStores } from "@lib/helpers";
import { getRegions } from "@store/user/actions";
import { getStores } from "@store/stores/actions";
import { getSupportCategories } from "@store/support/actions";

import Breadcrumbs from "@components/Breadcrumbs";
import SupportLayout from "@containers/Support/Layout";
import ErrorPage from "@containers/ErrorPage";
import StoresLayout from "@components/Stores/StoresLayout";
import RegionContainer from "@containers/Stores/Region";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

class StoresRegionPage extends Component {
  render() {
    const { regionUrlKey, regions, stores, supportCategories } = this.props;

    // Find region name by urlKey
    const currentRegion =
      regions && regions.find((region) => region.url_key === regionUrlKey);

    // Check store data
    if (!stores || !currentRegion) {
      return <ErrorPage>Nu au fost gasite magazine</ErrorPage>;
    }

    // Get stores in the network
    const storesList = stores.filter(
      (store) => store.network === settings.websiteId
    );

    const regionsList = getRegionsWithStores({ regions, stores: storesList });

    return (
      <>
        <Head>
          <title>{`Magazine din regiunea ${currentRegion.name}`}</title>
        </Head>

        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              level: 2,
              name: `Suport clienti`,
              url_key: "suport-clienti/",
            },
            {
              id: 2,
              level: 3,
              name: `Magazine`,
              url_key: "magazine/",
            },
            {
              id: 3,
              level: 99,
              name: currentRegion.name,
            },
          ]}
        />

        <SupportLayout categories={supportCategories}>
          <StoresLayout
            title={`Magazine din regiunea ${currentRegion.name}`}
            regions={regionsList}
          >
            <RegionContainer
              regions={regionsList}
              stores={storesList}
              currentRegion={currentRegion}
            />
          </StoresLayout>
        </SupportLayout>
      </>
    );
  }
}

StoresRegionPage.getInitialProps = async (ctx) => {
  const { reduxStore, query, asPath: urlAsPath } = ctx;
  const { regionUrlKey } = query;

  // Get data from store
  const { categories } = reduxStore.getState().support;
  const { regions } = reduxStore.getState().user;
  const { stores } = reduxStore.getState();

  const promises = [];

  // Load data
  !categories && promises.push(reduxStore.dispatch(getSupportCategories()));
  !regions && promises.push(reduxStore.dispatch(getRegions()));
  !stores.data && promises.push(reduxStore.dispatch(getStores()));

  await Promise.all(promises);

  return {
    urlAsPath,
    regionUrlKey,
  };
};

StoresRegionPage.pageLayout = "default";
StoresRegionPage.layoutProps = {
  displaySearch: false,
};

export default withRouterPageLayout(
  connect((state) => ({
    stores: state.stores.data,
    regions: state.user.regions,
    supportCategories: state.support.categories,
  }))(StoresRegionPage)
);
